import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, InputGroup } from 'react-bootstrap';

import logo from '../assets/images/logo.svg';
import globe from '../assets/images/map-global.png';

import { useNavigate } from 'react-router-dom';
import websiteInfo from '../config/websiteInfo';
import { subscribeNewsletter } from '../services/apiService';

const Footer = () => {
  const navigate = useNavigate();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [newsletterMessage, setNewsletterMessage] = useState({ type: '', text: '' });
  return (
    <footer className="footer-section" >
      <Container>
        <Row>
          <Col xl={8}>
            <div className='cta-section mb-3'>
              <div className="footer-globe" style={{ backgroundImage: `url(${globe}` }}></div>

              <div className="cta-header mb-5 pb-5 pb-lg-4 mb-lg-0">
                <Row>
                  <Col lg={8}>
                    <h3 className='cta-title outline-text'>Ready for <span className='outline-theme-text'>Lift-Off </span>?</h3>
                    <p className='mb-lg-0 mb-3'>Your growth deserves better than guesswork. Let’s launch something big.</p>
                  </Col>
                  <Col lg={4} className="text-lg-end d-lg-flex align-items-center justify-content-md-end justify-content-center">
                    <Button variant="theme" className='btn-rounded' onClick={() => { navigate(`/contact-us`)}} >
                      <span className=" fs-14 fw-500">Let’s Get Started</span>
                      <span className="arrow-icon">
                        <i className="fa-solid fa-arrow-right icon"></i>
                        <i className="fa-solid fa-arrow-right icon"></i>
                      </span>
                    </Button>
                  </Col>
                </Row>
              </div>

              <div className='cta-footer'>
                <Row>
                  <Col lg={5} className='align-items-center d-flex'>
                    <img src={logo} className="App-logo mb-lg-0 mb-5 " alt="logo" />
                  </Col>
                  <Col lg={7} className="text-lg-end">
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/home`)}}>Home</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/services`)}}>Service</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/about-us`)}}>About Us</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/our-works`)}}>Our Works</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/case-study`)}}>Case Study</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/contact-us`)}}>Contact Us</Button>
                    <Button variant="outline-light" className='mb-1 me-2' onClick={() => { navigate(`/careers`)}}>Careers</Button>
                  </Col>
                </Row>
              </div>




            </div>
          </Col>
          <Col xl={4}>
            <div className="social-section mb-3">
              <div className="social-header mb-5 pb-5 pb-lg-0 mb-lg-0">
                <h4 className='mb-4'>Explore the Socials of Adrocket</h4>
                <div className="social-icons-wrapper">
                  <a 
                    href={websiteInfo.socialMedia.facebook.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link"
                    aria-label="Facebook"
                  >
                    <i className={websiteInfo.socialMedia.facebook.icon}></i>
                  </a>
                  <a 
                    href={websiteInfo.socialMedia.instagram.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link"
                    aria-label="Instagram"
                  >
                    <i className={websiteInfo.socialMedia.instagram.icon}></i>
                  </a>
                  <a 
                    href={websiteInfo.socialMedia.linkedin.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link"
                    aria-label="LinkedIn"
                  >
                    <i className={websiteInfo.socialMedia.linkedin.icon}></i>
                  </a>
                </div>
              </div>
              <div className="social-footer">
                <div className="newsletter">
                  <div className="newsletter-header">
                    <i className="fa-regular fa-envelope"></i>
                    <h5>Newsletter</h5>
                  </div>
                  <Form onSubmit={async (e) => {
                    e.preventDefault();
                    
                    // Validate email
                    if (!newsletterEmail.trim()) {
                      setNewsletterMessage({
                        type: 'error',
                        text: 'Please enter your email address'
                      });
                      return;
                    }
                    
                    // Email format validation
                    const emailRegex = /^\S+@\S+\.\S+$/;
                    if (!emailRegex.test(newsletterEmail)) {
                      setNewsletterMessage({
                        type: 'error',
                        text: 'Please enter a valid email address'
                      });
                      return;
                    }
                    
                    setIsSubscribing(true);
                    setNewsletterMessage({ type: '', text: '' });
                    
                    try {
                      const response = await subscribeNewsletter(newsletterEmail);
                      
                      if (response.success) {
                        setNewsletterMessage({
                          type: 'success',
                          text: response.message || 'Thank you for subscribing! Check your email for confirmation.'
                        });
                        setNewsletterEmail('');
                        
                        // Clear success message after 5 seconds
                        setTimeout(() => {
                          setNewsletterMessage({ type: '', text: '' });
                        }, 5000);
                      } else {
                        setNewsletterMessage({
                          type: 'error',
                          text: response.error || 'Failed to subscribe. Please try again later.'
                        });
                      }
                    } catch (error) {
                      setNewsletterMessage({
                        type: 'error',
                        text: 'An unexpected error occurred. Please try again later.'
                      });
                    } finally {
                      setIsSubscribing(false);
                    }
                  }}>
                    <InputGroup className="newsletter-input mb-3">
                      <Form.Control
                        placeholder="Enter your email address"
                        aria-label="Email address"
                        type="email"
                        className="email-input"
                        value={newsletterEmail}
                        onChange={(e) => setNewsletterEmail(e.target.value)}
                        disabled={isSubscribing}
                        required
                      />
                      <Button 
                        variant="theme" 
                        className="send-btn" 
                        type="submit"
                        disabled={isSubscribing}
                      >
                        {isSubscribing ? (
                          <i className="fa-solid fa-spinner fa-spin"></i>
                        ) : (
                          <i className="fa-brands fa-space-awesome"></i>
                        )}
                      </Button>
                    </InputGroup>
                  </Form>
                  
                  {/* Newsletter Success/Error Message */}
                  {newsletterMessage.text && (
                    <div className={`newsletter-message ${newsletterMessage.type === 'success' ? 'success' : 'error'}`}>
                      <p className="mb-0 fs-12">{newsletterMessage.text}</p>
                    </div>
                  )}
                  
                  <p className="newsletter-disclaimer">
                    By subscribing, you're accept our <a href="#privacy">Privacy Policy</a>
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col className='text-center'>
            <p className='text-white my-2'>&copy; {new Date().getFullYear()} <span className='text-theme'>AdRocket</span> All rights reserved. | Designed & Developed By <a href='https://veeyaainnovatives.com/' target='_blank' rel='noopener noreferrer' className='text-theme'>Veeyaa Innovatives</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;